import { Component } from '@angular/core';

@Component({
  selector: 'app-unlock-pdf-content',
  imports: [],
  templateUrl: './unlock-pdf-content.component.html',
  styleUrl: './unlock-pdf-content.component.css'
})
export class UnlockPdfContentComponent {

}
